module.exports = __webpack_public_path__ + "static/media/18ECA36.f26f5db1.jpg";